import { Eyebrow } from '#app/components/typography/eyebrow.js'
import { H3 } from '#app/components/typography/h3'
import { type Post } from '#app/routes/_marketing+/articles+/_index.js'

export const ArticlePreview = ({ post }: { post: Post }) => {
	return (
		<article className="bg-muted-900 relative isolate flex flex-col justify-end overflow-hidden rounded-2xl pt-80 px-8 pb-8 sm:pt-48 lg:pt-80">
			<img src={post.imageUrl} alt="" className="absolute inset-0 -z-10 h-full w-full object-cover" />
			<div className="from-muted-900 via-muted-900/40 absolute inset-0 -z-10 bg-gradient-to-t" />
			<div className="ring-muted-900/10 absolute inset-0 -z-10 rounded-2xl ring-1 ring-inset" />
			<Eyebrow className="text-background">{post.date}</Eyebrow>
			<H3 className="text-background mt-0">
				<a href={post.href}>
					{/* This span 👇 makes the link clickable on the entire area */}
					<span className="absolute inset-0" />
					{post.title}
				</a>
			</H3>
			<div className="text-size-sm text-muted-300 mt-4 flex flex-wrap items-center gap-1 overflow-hidden">
				{post.topics.map(topic => (
					<span key={topic} className="whitespace-nowrap">
						{topic}
					</span>
				))}
			</div>
		</article>
	)
}
